import $store from 'src/store'

import { HttpService } from 'src/services'
import $router from 'src/router'

export class Base {
  static get entity() {
    throw new Error('"entity" getter not defined')
  }

  static normalizeDatepickerView(viewType) {
    switch (viewType) {
      case 'daysOfMonth':
        return 'month'
      case 'monthsOfQuarter':
        return 'quarter'
      case 'monthsOfYear':
        return 'year'
      case 'custom':
        return 'custom'
    }
  }

  static get datepicker() {
    const {
      dealerGroupId,
      dealerShipId,
      viewType,
      year,
      month,
      quarter,
      startDate,
      endDate,
      customGroupId,
    } = $store.state.settings
    const isCustomGroup = $router.currentRoute.value.meta.customGroup

    const params = {
      dealerGroupId: +dealerGroupId,
      year: +year,
      month: +month,
      quarter: +quarter,
      view: this.normalizeDatepickerView(viewType),
    }

    if (viewType === 'custom') {
      params.startDate = startDate
      params.endDate = endDate
    }

    if (
      // Disabling new dealerShipId format in request for pages which don't support it
      !['need-attention', 'budget'].includes(this.entity)
    ) {
      params.dealerShipId =
        +dealerShipId === 0
          ? $store.getters['dealer/dealerships'].map((e) => e.id).join(',')
          : dealerShipId
    }

    if (isCustomGroup) {
      params.customGroupId = customGroupId
    } else {
      params.dealerShipId =
        String(dealerShipId).split(',').length > 0 ? dealerShipId : +dealerShipId
    }

    return params
  }

  static normalizeOptions(options) {
    return Object.fromEntries(
      Object.entries(options).map(([key, value]) => [`options[${key}]`, value])
    )
  }

  static request(payload = {}) {
    return new HttpService({
      auth: true,
      shouldCancelOnRoute: true,
      shouldCancelOnGet: true,
      shouldCatchError: true,
      ...payload,
    })
  }
}
